import {
  ArrowLeft,
  ArrowUpwardOutlined,
  ThumbDownOutlined,
} from "@mui/icons-material";
import { Loading } from "react-admin";
import { useEffect, useState } from "react";

export default function ShortQuestionAnswer(props) {
  const {
    styles,
    showLoader,
    sidePanel,
    submitAnswer,
    questionContent,
    handleOpenReportModal,
    fetchQuestion,
    showToast,
    isSolved,
    prevUserAnswer,
    moveQuestionIndex,
    currentQuestionIndex,
    latestQuestionIndex,
    remainingXP,
  } = props;
  const { question } = questionContent.content;
  const questionBlockId = questionContent.id;

  const [answer, setAnswer] = useState(null);
  const [disableAnswerInput, setDisableAnswerInout] = useState(false);
  const [questionPanelLoader, setQuestionPanelLoader] = useState(false);
  const [highlight, setHighlight] = useState(false);

  const nextQuestion = async () => {
    try {
      setQuestionPanelLoader(true);
      setDisableAnswerInout(true);
      setAnswer(null);
      await fetchQuestion();
    } catch (error) {
      console.error("Error in nextQuestion:", error);
      showToast("An error occurred while fetching the next question.", "error");
    } finally {
      setDisableAnswerInout(false);
      setQuestionPanelLoader(false);
    }
  };

  const handleSubmission = async (option) => {
    try {
      setDisableAnswerInout(true);
      setAnswer(option);
      await submitAnswer(option);
    } catch (error) {
      console.error("Error in handleSubmission:", error);
      showToast("An error occurred while Submitting your answer.", "error");
    } finally {
      setDisableAnswerInout(false);
    }
  };

  const moveIndex = async (direction) => {
    try {
      setDisableAnswerInout(true);
      setAnswer(null);
      await moveQuestionIndex(direction);
    } catch (error) {
      console.error("Error in moveIndex:", error);
      showToast(
        "An error occurred while moving to the next question.",
        "error"
      );
    } finally {
      setDisableAnswerInout(false);
    }
  };

  useEffect(() => {
    if (isSolved || answer === null) {
      setAnswer(prevUserAnswer);
    }
    setDisableAnswerInout(isSolved);
  }, [isSolved, currentQuestionIndex]);

  useEffect(() => {
    if (remainingXP < 10 && !showLoader) {
      setHighlight(true);
      setTimeout(() => {
        setHighlight(false);
      }, 800);
    }
  }, [remainingXP]);

  return (
    <div className={styles.question_option_panel}>
      <div
        className={`${styles.question_panel} ${
          !sidePanel && styles.side_panel_close
        }`}
      >
        <div className={styles.header}>
          <span className={styles.title}>
            Question{" "}
            <span className={`${highlight && styles.flash}`}>
              ({remainingXP} XP)
            </span>
          </span>
          <div className={styles.actions}>
            <ArrowLeft
              className={`${styles.action_btn} ${
                currentQuestionIndex === 0 && styles.disable
              }`}
              onClick={async () => {
                await moveIndex(-1);
              }}
            />
            <span className={styles.question_index}>
              {currentQuestionIndex + 1}
            </span>
            <ArrowLeft
              className={`${styles.action_btn} ${styles.left} ${
                latestQuestionIndex - currentQuestionIndex <= 0 &&
                styles.disable
              }`}
              onClick={async () => {
                await moveIndex(1);
              }}
            />
          </div>
        </div>

        {questionPanelLoader ? (
          <Loading
            loadingPrimary=""
            loadingSecondary="Generating Question..."
          />
        ) : (
          <div className={styles.question}>
            {question?.length > 0 ? (
              <>
                <div className={styles.question_wrapper}>
                  {question}
                  <button
                    title="Report"
                    onClick={() => {
                      handleOpenReportModal({
                        reportFor: "QUESTION",
                        blockId: questionBlockId || null,
                        index: currentQuestionIndex,
                      });
                    }}
                  >
                    <ThumbDownOutlined className={styles.icon} />
                  </button>
                </div>
                {isSolved && currentQuestionIndex === latestQuestionIndex && (
                  <div
                    className={styles.btn}
                    onClick={async () => await nextQuestion()}
                  >
                    Next Question
                  </div>
                )}
              </>
            ) : (
              "Something went wrong. Please try again."
            )}
          </div>
        )}
      </div>

      {!questionPanelLoader && (
        <div className={styles.option_panel}>
          <div className={styles.answer_input_wrapper}>
            <textarea
              className={styles.answer_input}
              placeholder="Type your answer here..."
              value={answer || ""}
              onChange={(e) => setAnswer(e.target.value)}
              disabled={disableAnswerInput || isSolved}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmission(answer);
                }
              }}
            ></textarea>
            <button
              className={styles.submit_btn}
              onClick={() => handleSubmission(answer)}
              disabled={disableAnswerInput || isSolved || !answer?.trim()}
            >
              <ArrowUpwardOutlined className={styles.icon} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
